__turbopack_context__.v({
  "discountHighlight": "PlansScreenAdapter-module-scss-module__vk39na__discountHighlight",
});
